/* src/components/subscribe/subscribe.component.scss */
.subscribe-container {
  background-color: var(--background);
  padding: 10px;
  border-radius: 5px;
}
.subscribe-container .header {
  font-weight: bold;
  padding: 5px 0px 5px 0px;
}
.subscribe-container .subscribe-option {
  width: 100%;
  display: flex;
  margin: 5px 0px 5px 0px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.subscribe-container .subscribe-option div {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.subscribe-container .subscribe-option .checkbox-container {
  flex: 0 0 0%;
  align-items: center;
  padding: 5px;
}
.subscribe-container .subscribe-option .text-container {
  flex: 1 1 100%;
  padding: 5px;
}
.subscribe-container .subscribe-option .text-container .title {
  font-size: 0.8em;
}
.subscribe-container .button-container {
  width: 100%;
}
/*# sourceMappingURL=subscribe.component.css.map */
